// Mensagem de erros
export const ERRO_NAO_ENVIADO = 'Dados não enviados, verifique se esta com internet';
export const ERRO_STATUS_NAO_200 = 'Erro interno do servidor, se persistir informar ao admin';

export const SET_ERRO = 'SET_ERRO';

export const setErro = (value)=>({
    type: SET_ERRO,
    value
})
